import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import { jsx as _jsx } from "react/jsx-runtime";
var sortingIcon = {
  asc: TriangleUpIcon,
  desc: TriangleDownIcon
};
export var SortingIcon = function SortingIcon(_ref) {
  var column = _ref.column;
  var isSorted = column.getIsSorted();

  if (!isSorted) {
    return null;
  }

  var Icon = sortingIcon[isSorted];
  return /*#__PURE__*/_jsx(Icon, {
    e2eid: "CrudTable_SortingIcon_Icon"
  });
};